import { Injectable } from '@angular/core';
import { FuseSplashScreenService } from '@barebone-fuse/@fuse/services/splash-screen.service';
import { CommandService } from '@core/services/command.service';
import { PlatformQueryService } from '@core/services/platform-query.service';
import { RightSideMagicBarStateService } from '@core/services/right-side-magic-bar/right-side-magic-bar-state.service';
import { Store } from '@ngrx/store';
import { PlatformSidebarState } from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import { MagicBarQuickViewService } from '@shared/components/platform-tool/platform-tool-magic-bar/services/magic-bar-quick-view.service';
import { MagicBarService } from '@shared/components/platform-tool/platform-tool-magic-bar/services/magic-bar.service';
import { ActivityRightSidebarStateService } from './activity-right-sidebar-state.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class DataTracingV2Service {


  constructor(
    private fuseSplashScreenService: FuseSplashScreenService,
    private platformQueryService: PlatformQueryService,
    private commandService: CommandService,
    private platformSidebarStore: Store<PlatformSidebarState>,
    private magicBarQuickViewService : MagicBarQuickViewService,
    private rightSideMagicBarStateService: RightSideMagicBarStateService,
    private magicBarService: MagicBarService,
    private activityRightSidebarStateService: ActivityRightSidebarStateService,
    private router: Router) {
  }

    public dataTracingChartQuery(dataEditSummaryId: string, sourceType: string)
    {
      console.log('LatestDataSourcesComponent getDataTracing', dataEditSummaryId, sourceType);

    }

}
